module.exports = __webpack_public_path__ + "img/nav-bg.a7e9b052.png";